/* =========================================================
   cosmic syrup · intro splash
   pixel UFO terminal typing → ship flight → dismiss
   homepage only · once per session · respects reduced-motion
   ========================================================= */
(function () {
  'use strict';

  var intro = document.getElementById('csIntro');
  if (!intro) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (sessionStorage.getItem('csIntroSeen') === '1' || reduced) {
    intro.parentNode.removeChild(intro);
    return;
  }

  /* skip button · user has full UX control */
  var skipBtn = document.getElementById('csIntroSkip');
  if (skipBtn) {
    skipBtn.addEventListener('click', function () {
      intro.classList.add('dismissed');
      sessionStorage.setItem('csIntroSeen', '1');
      setTimeout(function () {
        if (intro.parentNode) intro.parentNode.removeChild(intro);
      }, 700);
    });
  }

  /* generate dense micro-pixel starfield */
  var bg = document.getElementById('csIntroBg');
  for (var i = 0; i < 220; i++) {
    var star = document.createElement('div');
    star.className = 'star' + (Math.random() > 0.9 ? ' lg' : '');
    star.style.left = (Math.random() * 100) + '%';
    star.style.top  = (Math.random() * 100) + '%';
    star.style.opacity = (0.25 + Math.random() * 0.75).toFixed(2);
    bg.appendChild(star);
  }

  /* terminal typing · pulls copy from data-* attrs so theme editor controls it */
  var lines = [
    { el: document.getElementById('csIntroLine1'), text: intro.getAttribute('data-line-1') || '> signal sending...' },
    { el: document.getElementById('csIntroLine2'), text: intro.getAttribute('data-line-2') || '> frequency found' },
    { el: document.getElementById('csIntroLine3'), text: intro.getAttribute('data-line-3') || '> entering orbit' }
  ];
  var TYPE_SPEED = 32, LINE_PAUSE = 320, FINAL_PAUSE = 480;
  var lineIdx = 0, charIdx = 0;

  function startSequence() {
    lines[0].el.classList.add('typing');
    setTimeout(typeStep, 520);
  }

  function typeStep() {
    if (lineIdx >= lines.length) { setTimeout(launchShip, FINAL_PAUSE); return; }
    var line = lines[lineIdx];
    if (!line.el.classList.contains('typing')) line.el.classList.add('typing');
    if (charIdx <= line.text.length) {
      line.el.textContent = line.text.substring(0, charIdx);
      charIdx++;
      setTimeout(typeStep, TYPE_SPEED);
    } else {
      line.el.classList.remove('typing');
      lineIdx++; charIdx = 0;
      if (lineIdx < lines.length) lines[lineIdx].el.classList.add('typing');
      setTimeout(typeStep, LINE_PAUSE);
    }
  }

  function launchShip() {
    var ship = document.getElementById('csIntroShip');
    ship.classList.add('flying');

    /* pixel star trail */
    var trail = setInterval(function () {
      var rect = ship.getBoundingClientRect();
      if (rect.bottom < -40) return;
      var count = Math.random() > 0.4 ? 2 : 1;
      for (var k = 0; k < count; k++) {
        var s = document.createElement('div');
        s.className = 'cs-intro__trail-star' + (Math.random() > 0.78 ? ' bright' : '');
        s.style.left = (rect.left + rect.width / 2 + (Math.random() * 16 - 8)) + 'px';
        s.style.top  = (rect.bottom + Math.random() * 22) + 'px';
        intro.appendChild(s);
        setTimeout((function (node) { return function () { if (node.parentNode) node.parentNode.removeChild(node); }; })(s), 1600);
      }
    }, 35);

    setTimeout(function () {
      clearInterval(trail);
      intro.classList.add('dismissed');
      sessionStorage.setItem('csIntroSeen', '1');
      setTimeout(function () { if (intro.parentNode) intro.parentNode.removeChild(intro); }, 800);
    }, 2700);
  }

  startSequence();
})();
